import Vue from "vue";
import Router from "vue-router";
import store from "../store/index.js";
Vue.use(Router);

/* Layout */
import Layout from "../layout/web/index.vue";
import H5Layout from "../layout/h5/index.vue";
export const routes = [
  {
    path: "/h5/login",
    component: () => import("@/views/h5/login/index"),
    meta: { title: "书克编程-登录" },
  },
  {
    path: "/h5",
    component: H5Layout,
    meta: { requiresAuth: true },
    redirect: "/h5/home",
    children: [
      {
        path: "home",
        meta: { title: "首页" },
        component: () => import("@/views/h5/home/index.vue"),
      },
      {
        path: "my",
        meta: { title: "个人中心" },
        component: () => import("@/views/h5/my/index.vue"),
      },
    ],
  },
  {
    path: "/h5/goods_details",
    component: () => import("@/views/h5/goods/index.vue"),
    meta: { title: "书克编程 - 信息学编程课" },
  },
  {
    path: "/h5/goods_success",
    component: () => import("@/views/h5/goods/success.vue"),
    meta: { title: "付款成功" },
  },
  {
    path: "/h5/goods_tip",
    component: () => import("@/views/h5/goods/goodTip.vue"),
    meta: { title: "支付宝支付" },
  },
  {
    path: "/h5",
    component: H5Layout,
    redirect: "/h5/home",
    children: [
      { path: "home", component: () => import("@/views/h5/home/index.vue") },
      { path: "my", component: () => import("@/views/h5/my/index.vue") },
    ],
  },
  {
    path: "/h5/authorize",
    component: () => import("@/views/h5/authorize/index"),
  },
  {
    path: "/login",
    component: () => import("@/views/web/login/index"),
    meta: {
      title: "登录 - 书克智汇平台",
    },
  },
  {
    path: "/PasswordReset",
    component: () => import("@/views/web/login/PasswordReset"),
    meta: {
      title: "更改密码 - 书克智汇平台",
    },
  },
  {
    path: "/skVideoPlayer",
    component: () => import("@/components/VideoPlayer"),
    meta: {
      title: "视频播放 - 书克智汇平台",
    },
  },
  {
    path: "/",
    component: Layout,
    redirect: "/StudentCenter",
    meta: { requiresAuth: true },
  },
  {
    path: "/StudentCenter",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/home/index.vue"),
        meta: {
          title: "学员中心 - 书克智汇平台",
          herderTitle: "资源汇聚，助力成功",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/test",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/contesttext/index.vue"),
        meta: {
          title: "测评中心 - 书克智汇平台",
          herderTitle: "评估能力，展现实力",
          requiresAuth: true,
        },
      },
      {
        path: "/testDetails",
        component: () =>
          import("@/views/web/contesttext/components/details.vue"),
        meta: {
          title: "试卷详情 - 书克智汇平台",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/exam",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/contestexam/index.vue"),
        meta: {
          title: "真题演练 - 书克智汇平台",
          herderTitle: "真题在手，赛考无忧",
          requiresAuth: true,
        },
      },
      {
        path: "/examDetails",
        component: () =>
          import("@/views/web/contestexam/components/details.vue"),
        meta: {
          title: "试卷详情 - 书克智汇平台",
          herderTitle: "真题详情",
          requiresAuth: true,
        },
      },
      {
        path: "/contestexamObjiectiveProblem",
        component: () =>
          import(
            "@/views/web/contestexam/components/contestExamObjProblem.vue"
          ),
        meta: {
          title: "答题中 - 书克智汇平台",
          herderTitle: "做题中，请认真答题...",
          requiresAuth: true,
          hideNavbar: true,
        },
      },
      {
        path: "/contestexamProblem",
        component: () =>
          import("@/views/web/contestexam/components/contestExamProblem.vue"),
        meta: {
          title: "答题中 - 书克智汇平台",
          herderTitle: "做题中，请认真答题...",
          requiresAuth: true,
          hideNavbar: true,
        },
      },
    ],
  },
  {
    path: "/rank",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/contestrank/index.vue"),
        meta: {
          title: "书克赛事 - 书克智汇平台",
          herderTitle: "实践是检验学习成果的最好机会",
          requiresAuth: true,
        },
      },
      {
        path: "/rankDetails",
        component: () =>
          import("@/views/web/contestrank/components/details.vue"),
        meta: {
          title: "赛事详情 - 书克智汇平台",
          herderTitle: "赛事详情",
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: "/class",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/class/index.vue"),
        meta: {
          title: "我的班级 - 书克智汇平台",
          herderTitle: "共同成长，携手进步",
          requiresAuth: true,
        },
      },
      {
        path: "/classInfo",
        component: () => import("@/views/web/class/components/ClassInfo.vue"),
        meta: {
          title: "班级详情 - 书克智汇平台",
          herderTitle: "班级详情",
          requiresAuth: true,
        },
      },
      {
        path: "/lessonInfo",
        component: () => import("@/views/web/class/components/lessonInfo.vue"),
        meta: {
          title: "课节详情 - 书克智汇平台",
          herderTitle: "课节详情",
          requiresAuth: true,
        },
      },
      {
        path: "/mistakeNotebook",
        component: () => import("@/views/web/mistakeNotebook/index.vue"),
        meta: {
          title: "我的错题 - 书克智汇平台",
          herderTitle: "定期查看错题本，巩固薄弱知识点，避免重复犯错！",
          requiresAuth: true,
        },
      },
      {
        path: "/mistakeObjectiveProblem",
        component: () =>
          import("@/views/web/mistakeNotebook/components/objectiveProblem.vue"),
        meta: {
          title: "做题中 - 书克智汇平台",
          herderTitle: "做题中，请认真答题...",
          requiresAuth: true,
          hideNavbar: true,
        },
      },
      {
        path: "/mistakeProblem",
        component: () =>
          import("@/views/web/mistakeNotebook/components/problem.vue"),
        meta: {
          title: "做题中 - 书克智汇平台",
          herderTitle: "做题中，请认真答题...",
          requiresAuth: true,
          hideNavbar: true,
        },
      },
      {
        path: "/dailyObjectiveProblem",
        component: () =>
          import("@/views/web/home/dayProblem/objectiveProblem.vue"),
        meta: {
          title: "做题中 - 书克智汇平台",
          herderTitle: "做题中，请认真答题...",
          requiresAuth: true,
          hideNavbar: true,
        },
      },
      {
        path: "/dailyProblem",
        component: () => import("@/views/web/home/dayProblem/problem.vue"),
        meta: {
          title: "做题中 - 书克智汇平台",
          herderTitle: "做题中，请认真答题...",
          requiresAuth: true,
          hideNavbar: true,
        },
      },
      {
        path: "/dailyProblemList",
        component: () =>
          import("@/views/web/home/dayProblem/dayProblemList.vue"),
        meta: {
          title: "每日一练 - 书克智汇平台",
          herderTitle: "每日一练：提交记录",
          requiresAuth: true,
        },
      },
      {
        path: "/classObjectiveProblem",
        component: () =>
          import("@/views/web/class/components/ClassObjectiveProblem.vue"),
        meta: {
          title: "做题中 - 书克智汇平台",
          herderTitle: "做题中，请认真答题...",
          requiresAuth: true,
          hideNavbar: true,
        },
      },
      {
        path: "/classProblem",
        component: () =>
          import("@/views/web/class/components/ClassProblem.vue"),
        meta: {
          title: "做题中 - 书克智汇平台",
          herderTitle: "做题中，请认真答题...",
          requiresAuth: true,
          referenceId: null,
          hideNavbar: true,
        },
      },
      {
        path: "/classObjectiveStageProblem",
        component: () =>
          import("@/views/web/class/components/ClassObjectiveStageProblem.vue"),
        meta: {
          title: "做题中 - 书克智汇平台",
          herderTitle: "做题中，请认真答题...",
          requiresAuth: true,
          hideNavbar: true,
        },
      },
      {
        path: "/classStageProblem",
        component: () =>
          import("@/views/web/class/components/ClassStageProblem.vue"),
        meta: {
          title: "做题中 - 书克智汇平台",
          herderTitle: "做题中，请认真答题...",
          requiresAuth: true,
          referenceId: null,
          hideNavbar: true,
        },
      },
    ],
  },
  {
    path: "/user",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/user/index.vue"),
        meta: {
          title: "个人中心 - 书克智汇平台",
          herderTitle: "个人中心",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/download",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/download/index.vue"),
        meta: {
          title: "软件下载 - 书克智汇平台",
          herderTitle: "软件下载",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/question",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/question/index.vue"),
        meta: {
          title: "我的答疑 - 书克智汇平台",
          herderTitle: "在线辅导，一对一答疑",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/problems",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/problem/index.vue"),
        meta: {
          title: "编程题列表 - 书克智汇平台",
          herderTitle: "每天练一练，进步看得见",
          requiresAuth: true,
        },
      },
      {
        path: "/problem",
        component: () => import("@/views/web/problem/components/problem.vue"),
        meta: {
          title: "答题中 - 书克智汇平台",
          herderTitle: "答题中，请认真答题...",
          requiresAuth: true,
          hideNavbar: true,
        },
      },
    ],
  },
  {
    path: "/objectiveProblems",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/objectiveProblem/index.vue"),
        meta: {
          title: "客观题列表 - 书克智汇平台",
          herderTitle: "每天练一练，进步看得见",
          requiresAuth: true,
        },
      },
      {
        path: "/objectiveProblem",
        component: () =>
          import(
            "@/views/web/objectiveProblem/components/objectiveProblem.vue"
          ),
        meta: {
          title: "答题中 - 书克智汇平台",
          herderTitle: "答题中，请认真答题...",
          requiresAuth: true,
          hideNavbar: true,
        },
      },
    ],
  },
  {
    path: "/skRank",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/rank/index.vue"),
        meta: {
          title: "书克排名 - 书克智汇平台",
          herderTitle: "书克巅峰对决，排名彰显实力",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/submission",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/submission/index.vue"),
        meta: {
          title: "提交记录 - 书克智汇平台",
          herderTitle: "提交记录",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/scratch",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/web/scratch/index.vue"),
        meta: {
          title: "Scratch - 书克智汇平台",
          herderTitle: "创意编程，尽在 Scratch",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "*",
    component: () => import("@/views/404"),
    hidden: true,
  },
];

const createRouter = () =>
  new Router({
    mode: "history",
    scrollBehavior: () => ({ y: 0 }),
    routes: routes,
  });

const router = createRouter();
const WHITE_LIST = ["/login", "/h5/login", "/404"];

router.beforeEach(async (to, from, next) => {
  const defaultTitle = "书克智汇平台";
  document.title = to.meta.title || defaultTitle;

  try {
    if (store.getters["user/token"]) {
      await store.dispatch("user/fetchUserInfo");
    }
  } catch (error) {
    console.error("Error fetching user info:", error);
  }
  const hasToken = !!store.getters["user/token"];
  if (hasToken && to.path === "/h5/login") {
    next("/h5");
    return;
  }
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (hasToken) {
    next();
  } else {
    if (requiresAuth && !WHITE_LIST.includes(to.path)) {
      const loginPath = to.path.startsWith("/h5") ? "/h5/login" : "/login";
      if (!store.getters["user/isRedirecting"]) {
        store.commit("user/setIsRedirecting", true);
        next({
          path: loginPath,
          query: { redirect: to.fullPath },
          replace: true,
        });
      } else {
        next();
      }
    } else {
      next();
    }
  }
});
export const logout = () => {
  store.dispatch("user/clear");
  const currentPath = router.currentRoute.path;
  const loginPath = currentPath.startsWith("/h5") ? "/h5/login" : "/login";
  router.replace({
    path: loginPath,
    query: { redirect: router.currentRoute.fullPath },
  });
};
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
